import { featuresItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10 text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">平台优势</h2>
          <p className="text-foreground-500 text-sm mt-2">为什么千万吃瓜群众选择爆料网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-lg border border-background-200/60 p-6 text-center hover:border-primary-200 transition-colors cursor-pointer">
              <span className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="text-base font-medium text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}